import { Injectable } from '@angular/core';

declare global {
  interface Window {
    MSStream: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class DetectOsService {
  detectOS(): string {
    const userAgent = navigator.userAgent || navigator.vendor;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    return 'unknown';
  }
}
